import { isObject, omit } from 'lodash-es';
import Utils from 'helpers/Utils';
import filtersKeys from 'constants/filters';
import tableNames from 'constants/tableNames';
import Repository from './Repository';
import { AnyObject } from 'types/Common';

function foundQuickFilters(filtersSet) {
  const { filters, searchFilters } = filtersSet;

  return (
    searchFilters &&
    searchFilters.selectedCount === 0 &&
    filters &&
    Object.keys(getFilters(filters)).length === 0
  );
}

function getFilters(filters) {
  return omit(filters, '__lastApply');
}

function prepareDataForState(filtersSet, baseRequest, options?: any) {
  const { quickFilters, filters, searchFilters } = filtersSet;

  let filtersList = quickFilters;
  const isQuickFilters = foundQuickFilters(filtersSet);

  let isBaseFilters = false;

  // Согласно этому if-else определяется приоритет применение группы фильтров
  if (
    searchFilters &&
    searchFilters.selectedCount > 0 &&
    options?.tableName === tableNames.payments
  ) {
    filtersList = searchFilters.list;
  } else if (Object.keys(getFilters(filters)).length > 0) {
    filtersList = getFilters(filters);
    isBaseFilters = true;
  }

  const { filter } = baseRequest;

  for (const key in filtersList) {
    if (Utils.hasProp(filtersList, key)) {
      let item =
        isObject(filtersList[key]) && !Array.isArray(filtersList[key])
          ? filtersList[key].values
          : filtersList[key];

      if (typeof item === 'number') {
        filter[key] = String(item);
      } else if (item?.length) {
        if (key === filtersKeys.paymentStatus) {
          item = [...item];
          if (isQuickFilters && item.includes('refunded')) {
            item.push('partially refunded');
          }
          filter[key] = item;
        }
        filter[key] = item;
      }
    }
  }

  if (options?.tableName === tableNames.rcs) {
    const { listType } = baseRequest.filter;
    if (!listType || listType.length > 1) {
      baseRequest.filter.listType = 'both';
    } else if (listType.length === 1) {
      baseRequest.filter.listType = listType[0];
    }
  }

  if (options?.tableName === tableNames.payments) {
    baseRequest.saveFilter = isBaseFilters || Object.keys(filter).length === 0;
  }

  return baseRequest;
}

const getBatchPath = (path: string, id: string, name: string) =>
  `${path}/${encodeURIComponent(id)}?type=batch&name=${encodeURIComponent(
    name
  )}`;

const getTransactionPath = (path: string, id: string, name: string) =>
  `${path}/${encodeURIComponent(id)}?name=${encodeURIComponent(name)}`;

const getPathUrl = (tableName: tableNames, data: AnyObject) => {
  const { transactionId, paymentId, paymentOperationBatchId } = data || {};
  const isOldMenu =
    Repository.get('store').getState().layoutConfiguration.menuVersion ===
    'old';
  const basePath = isOldMenu ? '/manual-payments' : '/payouts';

  switch (tableName) {
    case tableNames.payments:
      return getTransactionPath('/payments', transactionId, paymentId);

    case tableNames.payouts:
    case tableNames.batch:
      return getTransactionPath(basePath, transactionId, paymentId);

    case tableNames.massPayouts:
      if (transactionId && paymentId) {
        return getTransactionPath(basePath, transactionId, paymentId);
      }

      return getBatchPath(
        basePath,
        paymentOperationBatchId,
        `Batch ${paymentOperationBatchId}`
      );

    case tableNames.manualPayments:
      if (transactionId && paymentId) {
        return getTransactionPath('/manual-payments', transactionId, paymentId);
      }

      return getBatchPath(
        '/manual-payments',
        paymentOperationBatchId,
        `Batch ${paymentOperationBatchId}`
      );

    case tableNames.fraud:
      return getTransactionPath('/risks', transactionId, paymentId);

    default:
      return '/';
  }
};

export { prepareDataForState, foundQuickFilters, getPathUrl };
